import moment from "moment";
import searchAutoFill from "../searchAutoFill/searchAutoFill.vue";
import mixedChart from "@/pages/chart/mixedChart.vue";
import inboxTable from "../inboxDetails/inboxTable.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { searchAutoFill, mixedChart, inboxTable },
  computed: {
    ...mapState({
      selectedDomain: state => state.selectedDomain
    })
  },
  data() {
    return {
      toDate: moment().toDate(),
      fromDate: null,
      daysType: "30_days",
    };
  },
  methods: {
    ...mapActions(["updateSelectedDomain"]),
    updateDates() {
      this.$emit("update-dates", {
        fromDate: this.fromDate,
        toDate: this.toDate,
      });
    },
    updateDomain(domain) {
      this.updateSelectedDomain(domain);
      console.log("Domain updated in emailDashboard:", domain);
    },
    calculateDateRange() {
      const periodMap = {
        "7_days": 7,
        "15_days": 15,
        "30_days": 30,
        "60_days": 60,
        "90_days": 90,
      };
      const days = periodMap[this.daysType] || 30;
      this.fromDate = moment(this.toDate).subtract(days, "days").startOf("day").toDate();
    },
    applyDateValue() {
      this.calculateDateRange();
    },
  },
  watch: {
    daysType() {
      this.calculateDateRange();
    },
    toDate() {
      this.calculateDateRange();
      this.updateDates();
    },
    fromDate() {
      this.updateDates();
    },
  },
  mounted() {
    this.calculateDateRange();
  }
};